import { render } from "./PosReceiptRefund.vue?vue&type=template&id=0f009c00&scoped=true&ts=true"
import script from "./PosReceiptRefund.vue?vue&type=script&lang=ts"
export * from "./PosReceiptRefund.vue?vue&type=script&lang=ts"

import "./PosReceiptRefund.vue?vue&type=style&index=0&id=0f009c00&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f009c00"]])

export default __exports__